import { render, staticRenderFns } from "./GdprTacito.vue?vue&type=template&id=cf2088fc&scoped=true&"
import script from "./GdprTacito.vue?vue&type=script&lang=js&"
export * from "./GdprTacito.vue?vue&type=script&lang=js&"
import style0 from "./GdprTacito.vue?vue&type=style&index=0&id=cf2088fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf2088fc",
  null
  
)

export default component.exports